import { render, staticRenderFns } from "./location_override.vue?vue&type=template&id=52a320f5&scoped=true&"
import script from "./location_override.vue?vue&type=script&lang=js&"
export * from "./location_override.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a320f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a320f5')) {
      api.createRecord('52a320f5', component.options)
    } else {
      api.reload('52a320f5', component.options)
    }
    module.hot.accept("./location_override.vue?vue&type=template&id=52a320f5&scoped=true&", function () {
      api.rerender('52a320f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_modal/tabs/location_override.vue"
export default component.exports